import { render, staticRenderFns } from "./AllSermons.vue?vue&type=template&id=05d95229&"
import script from "./AllSermons.vue?vue&type=script&lang=js&"
export * from "./AllSermons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports